<template>
    <div class="ts-overflow-scroll ts-max-h-screen">
        <ts-table :columns="columns" :records="todayrequests">
            <template v-slot="{ record }">
                <td style="vertical-align: middle;">
                    {{ record.request_time || " " }}
                </td>
                <td style="vertical-align: middle;">
                    {{ (record.shop && record.shop.shop_name) || " " }}
                </td>
                <td style="vertical-align: middle;">
                    {{ (record.shop && record.shop.phone_number) || " " }}
                </td>
                <td style="vertical-align: middle;">
                    {{ record.destination || " " }}
                </td>
                <td style="vertical-align: middle;">
                    {{
                        (record.package_type &&
                            record.package_type.package_type_kh) ||
                            " "
                    }}
                </td>
                <td style="vertical-align: middle;">
                    {{
                        (record.service_type &&
                            record.service_type.service_type_name_kh) ||
                            " "
                    }}
                </td>
            </template>
        </ts-table>
    </div>
</template>
<script>
export default {
    name: "viewTodayRequestList",
    props: ["todayrequests"],
    data() {
        return {};
    },
    computed: {
        columns() {
            return [
                {
                    name: this.$t("pickupRequest.requestDate")
                },
                {
                    name: this.$t("pickupRequest.shopName")
                },
                {
                    name: this.$t("pickupRequest.shopPhoneNumber")
                },
                {
                    name: this.$t("pickupRequest.destination")
                },
                {
                    name: this.$t("pickupRequest.packageType")
                },
                {
                    name: this.$t("pickupRequest.serviceType")
                }
            ];
        }
    }
};
</script>

<style lang="css" scoped>
table {
    width: 100%;
    border-collapse: collapse;
}
table thead tr th {
    text-transform: uppercase;
    padding: 4px 7px;
    background: rgb(218, 218, 218);
}
table tbody tr td {
    padding: 4px 7px;
}
</style>
